import { Icon20UnlockOutline, Icon56LockOutline } from '@vkontakte/icons';
import React, { memo } from 'react';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/blocks/Weblink/WeblinkList/SharingNewWeblinkList.types';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';

import styles from './SharingDisabledWeblinkBlock.css';

interface Props {
    variant: SHARING_VARIANT;
    isPublic?: boolean;
    onOpenAccessClick: () => void;
    isPhone?: boolean;
}

export const SharingDisabledWeblinkBlock = memo(({ variant, isPublic, onOpenAccessClick, isPhone }: Props) => {
    return (
        <div className={styles.emptyContainer} data-qa-id="sharing-access-disabled-state">
            {variant === SHARING_VARIANT.filesBiz || variant === SHARING_VARIANT.foldersBiz ? (
                <Icon56LockOutline className={styles.emptyStateIcon} />
            ) : (
                <div className={styles.emptyImage} />
            )}
            <h3 className={styles.emptyHeader}>Доступ по ссылке закрыт</h3>
            <p className={styles.emptyDescription}>
                Если передумаете — создадим новую ссылку,
                <br />
                ей можно будет поделиться
            </p>
            {!isPublic && (
                <Button
                    qaId="sharing-enable-button"
                    theme={'base'}
                    middle
                    onClick={onOpenAccessClick}
                    sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.middle}
                >
                    <div className={styles.openAccessButton}>
                        {variant !== SHARING_VARIANT.filesBiz && variant !== SHARING_VARIANT.foldersBiz && (
                            <Icon20UnlockOutline width={20} height={20} />
                        )}
                        <span>Открыть доступ</span>
                    </div>
                </Button>
            )}
        </div>
    );
});

SharingDisabledWeblinkBlock.displayName = 'SharingDisabledWeblinkBlock';
